/**
 * Novanalyse — auth brand voice & ecosystem config.
 *
 * The premium login's copy + the four-pillar ecosystem framing in one place, so the brand canvas,
 * the footer and the mobile header share a single source of truth. Laboratoire register (clinical
 * ownership of the SIL/LIS), on the existing NOVERA navy/cyan identity — NO parallel identity, no
 * marketing fluff. FR is the canonical authored copy (the auth chrome is the FR-default surface).
 */

export interface BrandCopy {
  wordmark: string;
  /** The cyan second word in the wordmark lockup. */
  wordmarkAccent: string;
  eyebrow: string;
  tagline: string;
  positioning: string;
  accentSerif: string;
  /** Rotating capability lines (laboratoire-framed), cross-faded on the canvas. */
  capabilityLines: string[];
  copyright: string;
  legalName: string;
  legalUrl: string;
  /** The secure-footer microcopy under the form. */
  secure: string;
}

export const BRAND: BrandCopy = {
  wordmark: "novanalyse",
  wordmarkAccent: " laboratoire",
  eyebrow: "Système d'information de laboratoire · Algérie",
  tagline: "Le résultat, maîtrisé.",
  positioning:
    "Réception, paillasse, contrôle qualité, validation, caisse — un seul laboratoire numérique.",
  accentSerif: "Conçu avec et pour les biologistes.",
  capabilityLines: [
    "Dossier d'analyse traçable, de la réception à la validation.",
    "Connexion automate, résultats rapatriés sans ressaisie.",
    "Contrôle qualité Levey-Jennings et règles de Westgard intégrés.",
    "Validation biologique signée, médico-légale.",
    "Résultats restitués au patient — avec son consentement.",
  ],
  copyright: "© Novanalyse · Alger · v1.0",
  legalName: "novera",
  legalUrl: "novera-dz.com",
  secure: "Connexion chiffrée · Conforme Loi 18-07",
};

export type EcosystemKey = "novera" | "novanalyse" | "pharmakon" | "ailaji";

export interface EcosystemPillar {
  key: EcosystemKey;
  name: string;
  role: string;
  active?: boolean;
}

/**
 * The Pharmakon / Novera ecosystem pillars. `key` drives the minimal authored glyph
 * (EcosystemStrip); `active` highlights the current product (Novanalyse — the laboratoire half).
 */
export const ECOSYSTEM: ReadonlyArray<EcosystemPillar> = [
  { key: "novanalyse", name: "Novanalyse", role: "Le laboratoire", active: true },
  { key: "novera", name: "Novera Med", role: "Le cabinet médical" },
  { key: "pharmakon", name: "Pharmakon", role: "La pharmacie" },
  { key: "ailaji", name: "Ailaji · علاجي", role: "Le patient" },
];
